import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

import jsPDF from "jspdf";
import "jspdf-autotable";
import JSBarcode from "jsbarcode";
import canvas from "canvas";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submittedDateFrom: new Date(),
      submittedDateTo: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
    };
  }

  componentDidMount = () => {};

  handleSearch = () => {
    let url = "/api/traces/v1/document/list-awb";
    let group = [];
    let branch_id = [];
    this.state.user.principal_group.forEach((item, index) => {
      group.push(item.principal_code);
    });
    this.state.user.branch.forEach((item, index) => {
      branch_id.push(item.org_id);
    });

    let param = {
      group: group,
      branch: branch_id,
      source: "arman",
      submit_from:
        this.state.submittedDateFrom != ""
          ? moment(new Date(this.state.submittedDateFrom)).format("YYYY-MM-DD")
          : "",
      submit_to:
        this.state.submittedDateTo != ""
          ? moment(new Date(this.state.submittedDateTo)).format("YYYY-MM-DD")
          : "",
    };
    // let param = {
    //     org_id: this.state.user.org_id
    // }
    this.setState({ loading: true });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "AWB NO",
          accessor: "awb_no",
          filterable: true,
        },
        {
          Header: "AWB SUBMITTED DATE",
          accessor: "awb_submitted_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        {
          Header: "AWB CONFIRMED DATE",
          accessor: "awb_confirmed_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        {
          Header: "",
          accessor: "awb_no",
          Cell: (row) => (
            <span>
              <button
                className="btn btn-success btn-sm"
                onClick={() => {
                  this.goDetail(row);
                }}
              >
                Reprint
              </button>
            </span>
          ),
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ submittedDateFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ submittedDateTo: date });
  };

  goDetail = (rows) => {
    let { row } = rows;
    let awb = "";
    // this.props.history.push(
    //   "/admin/program/EditBudgetSummary/" + row.program_id
    // );

    let dataset = [];
    let url = "/api/traces/v1/document/detail-awb";
    let group = [];
    let branch_id = [];
    this.state.user.principal_group.forEach((item, index) => {
      group.push(item.principal_code);
    });
    this.state.user.branch.forEach((item, index) => {
      branch_id.push(item.org_id);
    });

    awb = row.awb_no;

    let param = {
      group: group,
      branch: branch_id,
      source: "arman",
      awb_no: awb,
    };
    // let param = {
    //     org_id: this.state.user.org_id
    // }
    this.setState({ loading: true });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        dataset = data;

        this.setState({ loading: false });
        this.exportPDF(dataset, awb);
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  thousandSeparator = (value) => {
    value = value.toString();
    value = value.replace(/,/g, "").replace(/(?!^-)[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  exportPDF = (dataset, awb_no) => {
    console.log(awb_no);
    console.log(dataset);
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 160;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(14);

    const newcanvas = canvas.createCanvas(0, 0);
    JSBarcode(newcanvas, awb_no, { displayValue: true });
    var imgData = newcanvas.toDataURL("image/png");
    const title = "SURAT PENGANTAR DOKUMEN CLAIM";
    const headers = [
      [
        "Claim Number",
        "Customer Name",
        "Principal",
        "Amount",
        "Submitted Date",
      ],
    ];

    const data = dataset.map((elt) => [
      elt.claim_number,
      elt.customer_name,
      elt.principal,
      this.thousandSeparator(elt.total),
      moment(elt.creation_date).format("DD-MMM-YYYY"),
    ]);

    console.log(dataset);

    let content = { startY: 150, head: headers, body: data };

    doc.text(title, marginLeft, 40);
    doc.setFontSize(10);
    doc.text(
      "AWB No: " + awb_no,
      doc.internal.pageSize.width / 2,
      60,
      null,
      null,
      "center"
    );
    doc.addImage(imgData, "PNG", 232, 70, 125, 50);
    doc.autoTable(content);

    let finalY = doc.lastAutoTable.finalY;
    doc.text(
      moment(new Date()).format("DD-MMM-YYYY"),
      450,
      finalY + 30,
      null,
      null,
      "center"
    );
    doc.text("Yang mengajukan,", 450, finalY + 40, null, null, "center");
    doc.text(
      "(" + this.state.user.realname + ")",
      450,
      finalY + 100,
      null,
      null,
      "center"
    );
    doc.save(awb_no + ".pdf");
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    {/*<div className="row">
                       <div className="col-md-6 float-left">
                       <div className="row">
                          <div className="col-lg-6">
                            <select
                              name=""
                              className="form-control"
                              onChange={this.handleChangeStatus.bind(this)}
                            >
                              <option value="">ALL</option>
                              <option value="propose">Propose</option>
                              <option value="app_princ">
                                Approved by Principal
                              </option>
                              <option value="val">Validated</option>
                              <option value="app_aam">Approved by AAM</option>
                              <option value="rej_aam">Rejected by AAM</option>
                              <option value="rej_princ">
                                Rejected by Principal
                              </option>
                            </select>
                          </div>
                        </div> 
                        </div>
                        </div>
                        */}

                    <div className="row">
                      <div className="row">
                        <div className="col-lg-2">Submit Date</div>
                        <div className="col-lg-3">
                          <DatePicker
                            placeholder="Submitted Date from"
                            selected={this.state.submittedDateFrom}
                            dateFormat="d-MMM-yyyy"
                            className="form-control myDatePicker"
                            popperPlacement="bottom-end"
                            onChange={this.handleSubmittedDateFrom}
                          />
                        </div>
                        <div className="col-lg-1"> To </div>
                        <div className="col-lg-3">
                          <DatePicker
                            placeholder="Submitted Date from"
                            selected={this.state.submittedDateTo}
                            dateFormat="d-MMM-yyyy"
                            className="form-control"
                            popperPlacement="bottom-end"
                            onChange={this.handleSubmittedDateTo}
                          />
                        </div>
                        <div className="col-md-2">
                          <button
                            className="btn btn-primary btn-block"
                            onClick={this.handleSearch.bind(this)}
                          >
                            <i class="fas fa-search"></i> Search
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 float-right">
                      <div className="row">
                        {/* <div className="col-lg-6">
                                                        <input type="text" className="form-control" onChange={ this.handleSearch.bind(this) } placeholder="Search Program..." value={ this.state.search } />
                                                    </div> */}
                        <div className="col-lg-6 float-right">
                          {/* <button className="btn btn-success"><i className="fas fa-file-excel" /></button> */}
                          {/* {this.exportToExcel()} */}
                        </div>
                      </div>
                    </div>

                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Summary;
